export const translations = {
  en: {
    // Navbar
    nav: {
      home: "Home",
      collection: "Collection",
      ourStory: "Our Story",
      contact: "Contact",
      lightMode: "Light Mode",
      darkMode: "Dark Mode",
      signOut: "Sign Out",
      myAccount: "My Account",
      trackOrder: "Track Order",
    },
    // Hero
    hero: {
      badge: "Luxury Fragrances",
      brandArabic: "بَيْتُ الطِّيبِ",
      brandEnglish: "BAIT AL-TEEB",
      tagline: "طَيِّبُ الرِّيحِ .. خَفِيفُ المَحْمَلِ",
      exploreCollection: "Explore Collection",
      ourStory: "Our Story",
    },
    // Featured Products
    featured: {
      badge: "The Collection",
      title: "Best Sellers",
      description: "Each fragrance tells a story of Arabian heritage, crafted with the finest ingredients from around the world.",
      noProducts: "No products available yet. Check back soon!",
      loading: "Loading collection...",
    },
    // Features Section
    features: {
      badge: "Why Choose Us",
      title: "The Art of Perfumery",
      items: [
        { title: "Rare Ingredients", description: "Sourced from the finest oud forests of Cambodia and the rose gardens of Damascus." },
        { title: "Pure & Natural", description: "No synthetic fragrances. Only the purest essential oils and natural extracts." },
        { title: "Master Crafted", description: "Blended by world-renowned perfumers with decades of expertise." },
        { title: "Heritage", description: "Recipes passed down through generations, honoring Arabian tradition." },
      ],
    },
    // Track Order
    track: {
      badge: "Order Tracking",
      title: "Track Your Orders",
      description: "Enter your email or phone number to view all your orders",
      placeholder: "Enter email or phone number...",
      searchBtn: "Track",
      searching: "Searching...",
      found: "Found",
      orders: "orders",
      order: "order",
      noResult: "No orders found. Please check your email or phone number and try again.",
      searchAgain: "Search Again",
      errorEmpty: "Please enter an email or phone number",
      errorNotFound: "No orders found with that email or phone number",
      email: "Email",
      phone: "Phone",
      orderJourney: "Order Journey",
      items: "items",
      item: "item",
      status: {
        pending: { label: "Pending", description: "Your order is being processed" },
        confirmed: { label: "Confirmed", description: "Your order has been confirmed" },
        processing: { label: "Processing", description: "Your order is being prepared" },
        shipped: { label: "Shipped", description: "Your order is on its way" },
        delivered: { label: "Delivered", description: "Your order has been delivered" },
      },
    },
    // Collection Page
    collection: {
      badge: "Discover",
      title: "Our Collection",
      description: "Explore our curated selection of the world's most exquisite fragrances, each crafted with passion and heritage.",
      searchPlaceholder: "Search fragrances...",
      noResults: "No fragrances found",
      noResultsDesc: "Try adjusting your filters or search query to discover more of our collection.",
      resetFilters: "Reset all filters",
      filters: "Filters",
      sort: "Sort",
      refine: "Refine",
      category: "Category",
      priceRange: "Price Range",
      sortBy: "Sort By",
      active: "active",
      resetAll: "Reset all",
      products: "products",
      product: "product",
      showProducts: "Show",
      sortOptions: {
        newest: "Newest First",
        oldest: "Oldest First",
        priceAsc: "Price: Low → High",
        priceDesc: "Price: High → Low",
        nameAsc: "Name: A → Z",
        nameDesc: "Name: Z → A",
      },
    },
    // Product Detail
    productDetail: {
      back: "Back",
      notFound: "Product not found",
      selectSize: "Select Size",
      quantity: "Quantity",
      addToCart: "Add to Cart",
      story: "The Fragrance Story",
      ingredients: "Ingredients",
      usages: "Usages",
      topNotes: "Top Notes",
      heartNotes: "Heart Notes",
      baseNotes: "Base Notes",
      keyIngredients: "Key Ingredients",
      whenToWear: "When to use",
      winter: "Winter",
      spring: "Spring",
      summer: "Summer",
      fall: "Fall",
      day: "Day",
      night: "Night",
      similar: "You May Also Like",
      outOfStock: "Out of Stock",
    },
    // Product Card
    productCard: {
      addToCart: "Add to Cart",
    },
    // Our Story Page
    story: {
      badge: "Since 2016",
      title: "Our Story",
      titleArabic: "قصتنا",
      legacyTitle: "Bait Al-Teeb",
      legacyP1: "In the world of fragrances, where memories hide within every note, Bait Al-Teeb was born to offer an exceptional aromatic experience.\n\nOur name, meaning \"House of Fragrance,\" is not just a name — it's a promise of quality and passion for the world of scents. At Bait Al-Teeb, we believe that fragrance is not a luxury, but a personal signature that expresses its wearer.",
      legacyP2: "That's why we carefully select the finest available fragrance oils to create high-quality inspired perfumes that combine lasting power with precise matching to the world's most renowned fragrances.\n\nWe pay attention to every detail in the perfume, from selecting the right oil to expert blending, to give you an experience that lasts and leaves an unforgettable impression.",
      philosophyBadge: "Our Mission",
      philosophyTitle: "Our Vision",
      pillars: [
        { title: "Quality", arabic: "الجودة", description: "We carefully select the finest fragrance oils to deliver perfumes with exceptional longevity and high-precision matching." },
        { title: "Passion", arabic: "الشغف", description: "We believe fragrance is a personal signature that expresses its wearer, so we care about every detail from selection to blending." },
        { title: "Value", arabic: "القيمة", description: "Our goal is to offer luxurious fragrances with premium quality at a price accessible to everyone." },
      ],
      craftBadge: "The Art of Creation",
      craftTitle: "Master Craftsmanship",
      craftQuote: "\"At Bait Al-Teeb, our goal is simple: to offer you luxurious fragrances with exceptional longevity, premium quality… at a price accessible to everyone.\"",
      craftAuthor: "— Bait Al-Teeb\nFine Scent .. Light to Carry",
      ctaTitle: "Begin Your Scent Journey",
      ctaDescription: "Discover luxurious fragrances with exceptional longevity, premium quality, at a price for everyone.",
      ctaButton: "Explore Collection",
    },
    // Contact Page
    contact: {
      badge: "Get in Touch",
      title: "Contact Us",
      description: "We would love to hear from you. Whether you have a question about our fragrances or need assistance, we're here to help.",
      sendMessage: "Send Us a Message",
      yourName: "Your Name",
      phoneNumber: "Phone Number",
      emailAddress: "Email Address",
      subject: "Subject",
      message: "Message",
      sendBtn: "Send Message",
      sending: "Sending...",
      contactInfo: "Contact Information",
      visitUs: "Visit Us",
      callUs: "Call Us",
      emailUs: "Email Us",
      openingHours: "Opening Hours",
      address: ["10th of Ramadan", "Cairo - Ismailia desert road", "Egypt"],
      hours: ["Sat - Thu: 9AM - 12AM", "Friday: 2PM - 12AM"],
      mapPlaceholder: "Interactive Map Coming Soon",
      successMsg: "Thank you for your message. We will respond shortly.",
    },
    // Login
    login: {
      title: "Welcome Back",
      subtitle: "Sign in to your account to continue",
      emailPlaceholder: "Email Address",
      passwordPlaceholder: "Password",
      signIn: "Sign In",
      signingIn: "Signing In...",
      noAccount: "Don't have an account?",
      createOne: "Create one",
      failed: "Login Failed",
      success: "Welcome back!",
      successDesc: "You have successfully signed in.",
      forgotPassword: "Forgot Password?",
    },
    // Signup
    signup: {
      title: "Create Account",
      subtitle: "Join us to explore our exclusive collection",
      fullName: "Full Name",
      emailPlaceholder: "Email Address",
      phonePlaceholder: "Phone Number",
      passwordPlaceholder: "Password",
      confirmPassword: "Confirm Password",
      createBtn: "Create Account",
      creating: "Creating Account...",
      hasAccount: "Already have an account?",
      signIn: "Sign in",
      failed: "Sign Up Failed",
      success: "Welcome!",
      successDesc: "Your account has been created successfully.",
      passwordMismatch: "Passwords do not match",
      passwordShort: "Password must be at least 6 characters",
    },
    // Checkout
    checkout: {
      continueShopping: "Continue Shopping",
      title: "Checkout",
      signInPrompt: "to track your order history, or continue as a guest.",
      contactInfo: "Contact Information",
      fullName: "Full Name *",
      email: "Email *",
      phone: "Phone *",
      shippingAddress: "Shipping Address",
      shippingPlaceholder: "Enter your full shipping address including city, state/province, postal code, and country",
      orderNotes: "Order Notes (Optional)",
      notesPlaceholder: "Any special instructions for your order...",
      placeOrder: "Place Order",
      processing: "Processing...",
      orderSummary: "Order Summary",
      qty: "Qty",
      subtotal: "Subtotal",
      shipping: "Shipping",
      shippingCalc: "Calculated after order",
      total: "Total",
      emptyCart: "Your Cart is Empty",
      emptyCartDesc: "Add some beautiful fragrances to your cart first.",
      browseCollection: "Browse Collection",
      orderConfirmed: "Order Confirmed!",
      orderConfirmedDesc: "Thank you for your order. The order will be confirmed by phone or WhatsApp.",
      orderId: "Order ID",
      signInRequired: "Sign In Required",
      signInRequiredDesc: "Please sign in to place an order",
      missingInfo: "Missing Information",
      missingInfoDesc: "Please fill in all required fields",
      emptyCartTitle: "Empty Cart",
      emptyCartDesc2: "Your cart is empty",
      orderFailed: "Order Failed",
      shippingTaxes: "Shipping & taxes calculated at checkout",
    },
    // Cart
    cart: {
      title: "Your Cart",
      empty: "Your cart is empty",
      emptyDesc: "Discover our exquisite collection",
      browseProducts: "Browse Products",
      trackOrder: "Track Your Order",
      subtotal: "Subtotal",
      checkout: "Proceed to Checkout",
      shippingNote: "Shipping & taxes calculated at checkout",
    },
    // Footer
    footer: {
      brandDesc: "Where heritage meets elegance. Crafting the finest Arabian fragrances since 2016.",
      explore: "Explore",
      exploreLinks: ["Collection", "New Arrivals", "Best Sellers", "Gift Sets"],
      support: "Support",
      supportLinks: ["Contact Us", "Shipping", "Returns", "FAQ"],
      stayConnected: "Stay Connected",
      subscribeDesc: "Subscribe for exclusive offers and new arrivals.",
      emailPlaceholder: "Your email",
      joinBtn: "Join",
      copyright: "© 2026 Bait Al-Teeb. All rights reserved to Bait Al-Teeb.",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      alreadySubscribed: "You're already subscribed!",
      subscribeSuccess: "Thank you for subscribing!",
    },
    // FAQ
    faq: {
      badge: "Help Center",
      title: "FAQ",
      subtitle: "Find answers to our most commonly asked questions",
      items: [
        { q: "How long does shipping take?", a: "We deliver within 2-5 business days across Egypt." },
        { q: "Do you offer cash on delivery?", a: "Yes! We accept cash on delivery across all Egyptian cities. You can also pay online during checkout." },
        { q: "Can I return or exchange a product?", a: "Yes, you can return or exchange unopened products within 7 days of delivery. Please contact us to initiate the process." },
        { q: "Are your fragrances original?", a: "Fragrances inspired by the world's most renowned scents, with elegant compositions and long-lasting performance." },
        { q: "How can I track my order?", a: "You can track your order using the 'Track Order' feature in our website. Just enter your email or phone number to see your order status." },
        { q: "Do you ship internationally?", a: "Currently we ship within Egypt only. International shipping will be available soon." },
        { q: "How do I contact customer support?", a: "You can reach us via WhatsApp, our Contact page, or by calling us directly. We're available Saturday to Thursday, 9 AM to 12 AM." },
      ],
    },
    // Returns
    returns: {
      badge: "Our Policy",
      title: "Returns & Exchanges",
      sections: [
        { title: "Return Policy", content: "We want you to be completely satisfied with your purchase. If you are not happy with your order, you may return unopened and unused products within 7 days of delivery for a full refund or exchange." },
        { title: "How to Return", content: "To initiate a return, please contact our customer service team via WhatsApp or our Contact page. Provide your order number and reason for return. Our team will guide you through the process." },
        { title: "Exchange Policy", content: "If you'd like to exchange a product for a different fragrance or size, we're happy to help. Exchanges are subject to product availability and must be initiated within 7 days of delivery." },
        { title: "Refund Processing", content: "Once we receive and inspect the returned item, your refund will be processed within 3-5 business days. Refunds are issued to the original payment method or as store credit." },
        { title: "Non-Returnable Items", content: "Opened, used, or damaged products cannot be returned. Gift sets and promotional items are final sale unless defective." },
      ],
    },
    // Privacy Policy
    privacy: {
      badge: "Your Privacy",
      title: "Privacy Policy",
      sections: [
        { title: "Information We Collect", content: "We collect personal information you provide when creating an account, placing orders, or contacting us. This includes your name, email, phone number, and shipping address." },
        { title: "How We Use Your Information", content: "Your information is used to process orders, provide customer support, send order updates, and improve our services. We never sell your personal data to third parties." },
        { title: "Data Security", content: "We implement industry-standard security measures to protect your personal information. All transactions are encrypted and your data is stored securely." },
        { title: "Cookies", content: "We use cookies to enhance your browsing experience, remember your preferences, and analyze site traffic. You can manage cookie preferences in your browser settings." },
        { title: "Contact Us", content: "If you have questions about our privacy practices, please contact us through our Contact page or via WhatsApp." },
      ],
    },
    // Terms of Service
    terms: {
      badge: "Legal",
      title: "Terms of Service",
      sections: [
        { title: "Acceptance of Terms", content: "By accessing and using the Bait Al-Teeb website, you agree to be bound by these Terms of Service. If you do not agree, please do not use our services." },
        { title: "Products & Pricing", content: "All product descriptions and prices are subject to change without notice. We make every effort to display accurate product information, but we do not guarantee that descriptions are error-free." },
        { title: "Orders & Payment", content: "By placing an order, you agree to provide accurate and complete information. We reserve the right to refuse or cancel any order for any reason, including pricing errors or suspected fraud." },
        { title: "Shipping & Delivery", content: "Delivery times are estimates and not guaranteed. We are not responsible for delays caused by shipping carriers or circumstances beyond our control." },
        { title: "Limitation of Liability", content: "Bait Al-Teeb shall not be liable for any indirect, incidental, or consequential damages arising from the use of our products or services." },
      ],
    },
    notFound: {
      title: "Page Not Found",
      description: "The fragrance you're looking for seems to have vanished into the air. Let us guide you back to our collection.",
      returnHome: "Return Home",
    },
    // Common
    common: {
      all: "All",
      egp: "EGP",
      error: "Error",
    },
    // Forgot Password
    forgotPassword: {
      title: "Forgot Password",
      subtitle: "Enter your email to receive a password reset link",
      emailPlaceholder: "Email Address",
      sendBtn: "Send Reset Link",
      sending: "Sending...",
      sentTitle: "Email Sent!",
      sentDesc: "Check your inbox for a password reset link.",
      backToLogin: "Back to Login",
      error: "Error",
    },
    // Reset Password
    resetPassword: {
      title: "Reset Password",
      subtitle: "Enter your new password below",
      newPassword: "New Password",
      confirmPassword: "Confirm New Password",
      updateBtn: "Update Password",
      updating: "Updating...",
      successTitle: "Password Updated!",
      successDesc: "Your password has been successfully reset.",
      redirecting: "Redirecting you to the homepage...",
      invalidLink: "This reset link is invalid or has expired. Please request a new one.",
      backToLogin: "Back to Login",
      error: "Error",
      mismatch: "Passwords do not match",
      tooShort: "Password must be at least 6 characters",
    },
    wishlist: {
      badge: "Your Favorites",
      title: "Wishlist",
      loginPrompt: "Log in to view your wishlist",
      signIn: "Sign In",
      empty: "Your wishlist is empty",
      explore: "Explore Collection",
    },
  },
  ar: {
    nav: {
      home: "الرئيسية",
      collection: "المجموعة",
      ourStory: "قصتنا",
      contact: "اتصل بنا",
      lightMode: "الوضع الفاتح",
      darkMode: "الوضع الداكن",
      signOut: "تسجيل الخروج",
      myAccount: "حسابي",
      trackOrder: "تتبع الطلب",
    },
    hero: {
      badge: "عطور فاخرة",
      brandArabic: "بَيْتُ الطِّيبِ",
      brandEnglish: "BAIT AL-TEEB",
      tagline: "طَيِّبُ الرِّيحِ .. خَفِيفُ المَحْمَلِ",
      exploreCollection: "استكشف المجموعة",
      ourStory: "قصتنا",
    },
    featured: {
      badge: "المجموعة",
      title: "الأكثر مبيعاً",
      description: "كل عطر يروي قصة من التراث العربي، مصنوع بأجود المكونات من جميع أنحاء العالم.",
      noProducts: "لا توجد منتجات متاحة حالياً. تابعنا قريباً!",
      loading: "جاري تحميل المجموعة...",
    },
    features: {
      badge: "لماذا تختارنا",
      title: "فن صناعة العطور",
      items: [
        { title: "مكونات نادرة", description: "مصدرها من أفخر غابات العود في كمبوديا وحدائق الورد في دمشق." },
        { title: "طبيعي ونقي", description: "بدون عطور صناعية. فقط أنقى الزيوت الأساسية والمستخلصات الطبيعية." },
        { title: "صناعة متقنة", description: "ممزوجة بأيدي أمهر صانعي العطور ذوي الخبرة العالمية." },
        { title: "التراث", description: "وصفات توارثتها الأجيال، تكريماً للتقاليد العربية العريقة." },
      ],
    },
    track: {
      badge: "تتبع الطلب",
      title: "تتبع طلباتك",
      description: "أدخل بريدك الإلكتروني أو رقم هاتفك لعرض جميع طلباتك",
      placeholder: "أدخل البريد الإلكتروني أو رقم الهاتف...",
      searchBtn: "تتبع",
      searching: "جاري البحث...",
      found: "تم العثور على",
      orders: "طلبات",
      order: "طلب",
      noResult: "لم يتم العثور على طلبات. يرجى التحقق من بريدك الإلكتروني أو رقم هاتفك والمحاولة مرة أخرى.",
      searchAgain: "البحث مرة أخرى",
      errorEmpty: "يرجى إدخال البريد الإلكتروني أو رقم الهاتف",
      errorNotFound: "لم يتم العثور على طلبات بهذا البريد أو الرقم",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      orderJourney: "رحلة الطلب",
      items: "عناصر",
      item: "عنصر",
      status: {
        pending: { label: "قيد الانتظار", description: "جاري معالجة طلبك" },
        confirmed: { label: "مؤكد", description: "تم تأكيد طلبك" },
        processing: { label: "قيد التحضير", description: "جاري تحضير طلبك" },
        shipped: { label: "تم الشحن", description: "طلبك في الطريق" },
        delivered: { label: "تم التوصيل", description: "تم توصيل طلبك" },
      },
    },
    collection: {
      badge: "اكتشف",
      title: "مجموعتنا",
      description: "استكشف تشكيلتنا المختارة من أرقى العطور في العالم، كل منها مصنوع بشغف وأصالة.",
      searchPlaceholder: "ابحث عن العطور...",
      noResults: "لم يتم العثور على عطور",
      noResultsDesc: "حاول تعديل الفلاتر أو البحث لاكتشاف المزيد من مجموعتنا.",
      resetFilters: "إعادة تعيين الكل",
      filters: "الفلاتر",
      sort: "الترتيب",
      refine: "تصفية",
      category: "الفئة",
      priceRange: "نطاق السعر",
      sortBy: "ترتيب حسب",
      active: "نشط",
      resetAll: "إعادة تعيين الكل",
      products: "منتجات",
      product: "منتج",
      showProducts: "عرض",
      sortOptions: {
        newest: "الأحدث أولاً",
        oldest: "الأقدم أولاً",
        priceAsc: "السعر: من الأقل للأعلى",
        priceDesc: "السعر: من الأعلى للأقل",
        nameAsc: "الاسم: أ → ي",
        nameDesc: "الاسم: ي → أ",
      },
    },
    productDetail: {
      back: "رجوع",
      notFound: "المنتج غير موجود",
      selectSize: "اختر الحجم",
      quantity: "الكمية",
      addToCart: "أضف إلى السلة",
      story: "قصة العطر",
      ingredients: "المكونات",
      usages: "الاستخدامات",
      topNotes: "المقدمة",
      heartNotes: "القلب",
      baseNotes: "القاعدة",
      keyIngredients: "المكونات الرئيسية",
      whenToWear: "متى تستخدمه",
      winter: "الشتاء",
      spring: "الربيع",
      summer: "الصيف",
      fall: "الخريف",
      day: "النهار",
      night: "الليل",
      similar: "قد يعجبك أيضاً",
      outOfStock: "نفذ من المخزون",
    },
    productCard: {
      addToCart: "أضف إلى السلة",
    },
    story: {
      badge: "منذ 2016",
      title: "قصتنا",
      titleArabic: "قصتنا",
      legacyTitle: "بيت الطيب",
      legacyP1: "في عالم العطور، حيث تختبئ الذكريات داخل كل نفحة، وُلد بيت الطيب ليقدم تجربة عطرية استثنائية.\n\nاسمنا الذي يعني بيت العطر ليس مجرد اسم، بل وعدٌ بالجودة والشغف بعالم الروائح. في بيت الطيب نؤمن أن العطر ليس رفاهية، بل هو بصمة شخصية تعبّر عن صاحبها.",
      legacyP2: "لهذا نختار بعناية أفضل الزيوت العطرية المتوفرة لنقدم عطور تركيب عالية الجودة، تجمع بين قوة الثبات ودقة التطابق مع أشهر العطور العالمية.\n\nنحن نهتم بكل تفصيلة في العطر، من اختيار الزيت المناسب إلى المزج المتقن، لنمنحك تجربة تدوم وتترك أثراً لا يُنسى.",
      philosophyBadge: "هدفنا",
      philosophyTitle: "رؤيتنا",
      pillars: [
        { title: "الجودة", arabic: "الجودة", description: "نختار بعناية أفضل الزيوت العطرية لنقدم عطوراً بثبات مميز ودقة تطابق عالية." },
        { title: "الشغف", arabic: "الشغف", description: "نؤمن أن العطر بصمة شخصية تعبّر عن صاحبها، لذا نهتم بكل تفصيلة من الاختيار إلى المزج." },
        { title: "القيمة", arabic: "القيمة", description: "هدفنا تقديم عطور فاخرة بجودة عالية وبسعر مناسب للجميع." },
      ],
      craftBadge: "فن الإبداع",
      craftTitle: "الحرفية المتقنة",
      craftQuote: "\"في بيت الطيب، هدفنا بسيط: أن نقدم لك عطوراً فاخرة، بثبات مميز، وجودة عالية… وبسعر مناسب للجميع.\"",
      craftAuthor: "— بيت الطيب\nطيب الريح .. خفيف المحمل",
      ctaTitle: "ابدأ رحلتك العطرية",
      ctaDescription: "اكتشف عطوراً فاخرة بثبات مميز وجودة عالية وبسعر مناسب للجميع.",
      ctaButton: "استكشف المجموعة",
    },
    contact: {
      badge: "تواصل معنا",
      title: "اتصل بنا",
      description: "يسعدنا سماعك. سواء كان لديك سؤال حول عطورنا أو تحتاج مساعدة، نحن هنا لخدمتك.",
      sendMessage: "أرسل لنا رسالة",
      yourName: "اسمك",
      phoneNumber: "رقم الهاتف",
      emailAddress: "البريد الإلكتروني",
      subject: "الموضوع",
      message: "الرسالة",
      sendBtn: "إرسال الرسالة",
      sending: "جاري الإرسال...",
      contactInfo: "معلومات الاتصال",
      visitUs: "زُرنا",
      callUs: "اتصل بنا",
      emailUs: "راسلنا",
      openingHours: "ساعات العمل",
      address: ["العاشر من رمضان", "طريق القاهرة - الإسماعيلية الصحراوي", "مصر"],
      hours: ["السبت - الخميس: 9 صباحاً - 12 مساءً", "الجمعة: 2 ظهراً - 12 مساءً"],
      mapPlaceholder: "الخريطة التفاعلية قريباً",
      successMsg: "شكراً لرسالتك. سنرد عليك قريباً.",
    },
    login: {
      title: "مرحباً بعودتك",
      subtitle: "سجّل الدخول لحسابك للمتابعة",
      emailPlaceholder: "البريد الإلكتروني",
      passwordPlaceholder: "كلمة المرور",
      signIn: "تسجيل الدخول",
      signingIn: "جاري تسجيل الدخول...",
      noAccount: "ليس لديك حساب؟",
      createOne: "أنشئ حساباً",
      failed: "فشل تسجيل الدخول",
      success: "مرحباً بعودتك!",
      successDesc: "تم تسجيل الدخول بنجاح.",
      forgotPassword: "نسيت كلمة المرور؟",
    },
    signup: {
      title: "إنشاء حساب",
      subtitle: "انضم إلينا لاستكشاف مجموعتنا الحصرية",
      fullName: "الاسم الكامل",
      emailPlaceholder: "البريد الإلكتروني",
      phonePlaceholder: "رقم الهاتف",
      passwordPlaceholder: "كلمة المرور",
      confirmPassword: "تأكيد كلمة المرور",
      createBtn: "إنشاء حساب",
      creating: "جاري إنشاء الحساب...",
      hasAccount: "لديك حساب بالفعل؟",
      signIn: "تسجيل الدخول",
      failed: "فشل إنشاء الحساب",
      success: "مرحباً!",
      successDesc: "تم إنشاء حسابك بنجاح.",
      passwordMismatch: "كلمتا المرور غير متطابقتين",
      passwordShort: "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
    },
    checkout: {
      continueShopping: "متابعة التسوق",
      title: "إتمام الطلب",
      signInPrompt: "لتتبع سجل طلباتك، أو تابع كضيف.",
      contactInfo: "معلومات الاتصال",
      fullName: "الاسم الكامل *",
      email: "البريد الإلكتروني *",
      phone: "الهاتف *",
      shippingAddress: "عنوان الشحن",
      shippingPlaceholder: "أدخل عنوان الشحن الكامل متضمناً المدينة والمحافظة والرمز البريدي والدولة",
      orderNotes: "ملاحظات الطلب (اختياري)",
      notesPlaceholder: "أي تعليمات خاصة لطلبك...",
      placeOrder: "تأكيد الطلب",
      processing: "جاري المعالجة...",
      orderSummary: "ملخص الطلب",
      qty: "الكمية",
      subtotal: "المجموع الفرعي",
      shipping: "الشحن",
      shippingCalc: "يُحسب بعد الطلب",
      total: "الإجمالي",
      emptyCart: "سلة التسوق فارغة",
      emptyCartDesc: "أضف بعض العطور الجميلة إلى سلتك أولاً.",
      browseCollection: "تصفح المجموعة",
      orderConfirmed: "تم تأكيد الطلب!",
      orderConfirmedDesc: "شكراً لطلبك.سيتم تأكيد الطلب تلفونيا أو عن طريق الواتساب.",
      orderId: "رقم الطلب",
      signInRequired: "يجب تسجيل الدخول",
      signInRequiredDesc: "يرجى تسجيل الدخول لإتمام الطلب",
      missingInfo: "معلومات ناقصة",
      missingInfoDesc: "يرجى ملء جميع الحقول المطلوبة",
      emptyCartTitle: "سلة فارغة",
      emptyCartDesc2: "سلة التسوق فارغة",
      orderFailed: "فشل الطلب",
      shippingTaxes: "الشحن والضرائب تُحسب عند الدفع",
    },
    cart: {
      title: "سلة التسوق",
      empty: "سلة التسوق فارغة",
      emptyDesc: "اكتشف مجموعتنا الفاخرة",
      browseProducts: "تصفح المنتجات",
      trackOrder: "تتبع طلبك",
      subtotal: "المجموع الفرعي",
      checkout: "المتابعة للدفع",
      shippingNote: "الشحن والضرائب تُحسب عند الدفع",
    },
    footer: {
      brandDesc: "حيث يلتقي التراث بالأناقة. نصنع أرقى العطور العربية منذ 2016.",
      explore: "استكشف",
      exploreLinks: ["المجموعة", "وصل حديثاً", "الأكثر مبيعاً", "طقم هدايا"],
      support: "الدعم",
      supportLinks: ["اتصل بنا", "الشحن", "الإرجاع", "الأسئلة الشائعة"],
      stayConnected: "ابق على تواصل",
      subscribeDesc: "اشترك للحصول على العروض الحصرية والوصول الجديد.",
      emailPlaceholder: "بريدك الإلكتروني",
      joinBtn: "اشترك",
      copyright: "© 2026 بيت الطيب. جميع الحقوق محفوظة لبيت الطيب .",
      privacy: "سياسة الخصوصية",
      terms: "شروط الخدمة",
      alreadySubscribed: "أنت مشترك بالفعل!",
      subscribeSuccess: "شكراً لاشتراكك!",
    },
    faq: {
      badge: "مركز المساعدة",
      title: "الأسئلة الشائعة",
      subtitle: "اعثر على إجابات لأسئلتنا الأكثر شيوعاً",
      items: [
        { q: "كم يستغرق الشحن؟", a: "نوصل خلال 2-5 أيام عمل في جميع أنحاء مصر." },
        { q: "هل تقبلون الدفع عند الاستلام؟", a: "نعم! نقبل الدفع عند الاستلام في جميع المدن المصرية. يمكنك أيضاً الدفع أونلاين." },
        { q: "هل يمكنني إرجاع أو استبدال منتج؟", a: "نعم، يمكنك إرجاع أو استبدال المنتجات غير المفتوحة خلال 7 أيام من التوصيل. تواصل معنا لبدء العملية." },
        { q: "هل عطوركم أصلية؟", a: "عطور مستوحاه من أشهر الروائح العالمية، بتركيبات راقية وثبات يدوم." },
        { q: "كيف أتتبع طلبي؟", a: "يمكنك تتبع طلبك عبر خاصية 'تتبع الطلب' في موقعنا. أدخل بريدك الإلكتروني أو رقم هاتفك لمعرفة حالة طلبك." },
        { q: "هل تشحنون دولياً؟", a: "حالياً نشحن داخل مصر فقط. الشحن الدولي سيتوفر قريباً." },
        { q: "كيف أتواصل مع خدمة العملاء؟", a: "يمكنك التواصل معنا عبر واتساب أو صفحة اتصل بنا أو الاتصال مباشرة. نحن متاحون من السبت للخميس، 9 صباحاً حتى 12 مساءً." },
      ],
    },
    returns: {
      badge: "سياستنا",
      title: "الإرجاع والاستبدال",
      sections: [
        { title: "سياسة الإرجاع", content: "نريدك أن تكون راضياً تماماً عن مشترياتك. إذا لم تكن سعيداً بطلبك، يمكنك إرجاع المنتجات غير المفتوحة خلال 7 أيام من التوصيل لاسترداد كامل المبلغ أو الاستبدال." },
        { title: "كيفية الإرجاع", content: "لبدء عملية الإرجاع، تواصل مع فريق خدمة العملاء عبر واتساب أو صفحة اتصل بنا. قدم رقم طلبك وسبب الإرجاع وسيرشدك فريقنا خلال العملية." },
        { title: "سياسة الاستبدال", content: "إذا كنت ترغب في استبدال منتج بعطر أو حجم مختلف، يسعدنا مساعدتك. الاستبدال يخضع لتوفر المنتج ويجب أن يتم خلال 7 أيام من التوصيل." },
        { title: "معالجة المبالغ المستردة", content: "بمجرد استلامنا وفحص المنتج المرتجع، سيتم معالجة استردادك خلال 3-5 أيام عمل. يتم إصدار المبالغ المستردة بنفس طريقة الدفع الأصلية أو كرصيد في المتجر." },
        { title: "منتجات غير قابلة للإرجاع", content: "المنتجات المفتوحة أو المستخدمة أو التالفة لا يمكن إرجاعها. أطقم الهدايا والمنتجات الترويجية نهائية البيع ما لم تكن معيبة." },
      ],
    },
    privacy: {
      badge: "خصوصيتك",
      title: "سياسة الخصوصية",
      sections: [
        { title: "المعلومات التي نجمعها", content: "نجمع المعلومات الشخصية التي تقدمها عند إنشاء حساب أو تقديم طلبات أو التواصل معنا. تشمل اسمك وبريدك الإلكتروني ورقم هاتفك وعنوان الشحن." },
        { title: "كيف نستخدم معلوماتك", content: "تُستخدم معلوماتك لمعالجة الطلبات وتقديم دعم العملاء وإرسال تحديثات الطلبات وتحسين خدماتنا. لا نبيع بياناتك الشخصية لأطراف ثالثة أبداً." },
        { title: "أمان البيانات", content: "نطبق معايير أمان عالمية لحماية معلوماتك الشخصية. جميع المعاملات مشفرة وبياناتك مخزنة بأمان." },
        { title: "ملفات تعريف الارتباط", content: "نستخدم ملفات تعريف الارتباط لتحسين تجربة التصفح وتذكر تفضيلاتك وتحليل حركة المرور. يمكنك إدارة تفضيلات ملفات تعريف الارتباط في إعدادات متصفحك." },
        { title: "تواصل معنا", content: "إذا كانت لديك أسئلة حول ممارسات الخصوصية لدينا، تواصل معنا عبر صفحة اتصل بنا أو عبر واتساب." },
      ],
    },
    terms: {
      badge: "قانوني",
      title: "شروط الخدمة",
      sections: [
        { title: "قبول الشروط", content: "بالوصول إلى واستخدام موقع بيت الطيب، فإنك توافق على الالتزام بشروط الخدمة هذه. إذا لم توافق، يرجى عدم استخدام خدماتنا." },
        { title: "المنتجات والأسعار", content: "جميع أوصاف المنتجات والأسعار عرضة للتغيير دون إشعار. نبذل قصارى جهدنا لعرض معلومات دقيقة عن المنتجات، لكننا لا نضمن خلو الأوصاف من الأخطاء." },
        { title: "الطلبات والدفع", content: "بتقديم طلب، فإنك توافق على تقديم معلومات دقيقة وكاملة. نحتفظ بالحق في رفض أو إلغاء أي طلب لأي سبب، بما في ذلك أخطاء التسعير أو الاحتيال المشتبه به." },
        { title: "الشحن والتوصيل", content: "أوقات التوصيل تقديرية وغير مضمونة. لسنا مسؤولين عن التأخيرات التي تسببها شركات الشحن أو الظروف الخارجة عن إرادتنا." },
        { title: "حدود المسؤولية", content: "لا يتحمل بيت الطيب المسؤولية عن أي أضرار غير مباشرة أو عرضية أو تبعية ناتجة عن استخدام منتجاتنا أو خدماتنا." },
      ],
    },
    notFound: {
      title: "الصفحة غير موجودة",
      description: "يبدو أن العطر الذي تبحث عنه قد تبخّر في الهواء. دعنا نعيدك إلى مجموعتنا.",
      returnHome: "العودة للرئيسية",
    },
    common: {
      all: "الكل",
      egp: "ج.م",
      error: "خطأ",
    },
    forgotPassword: {
      title: "نسيت كلمة المرور",
      subtitle: "أدخل بريدك الإلكتروني لتلقي رابط إعادة التعيين",
      emailPlaceholder: "البريد الإلكتروني",
      sendBtn: "إرسال رابط التعيين",
      sending: "جاري الإرسال...",
      sentTitle: "تم الإرسال!",
      sentDesc: "تحقق من بريدك الإلكتروني للحصول على رابط إعادة تعيين كلمة المرور.",
      backToLogin: "العودة لتسجيل الدخول",
      error: "خطأ",
    },
    resetPassword: {
      title: "إعادة تعيين كلمة المرور",
      subtitle: "أدخل كلمة المرور الجديدة أدناه",
      newPassword: "كلمة المرور الجديدة",
      confirmPassword: "تأكيد كلمة المرور الجديدة",
      updateBtn: "تحديث كلمة المرور",
      updating: "جاري التحديث...",
      successTitle: "تم تحديث كلمة المرور!",
      successDesc: "تم إعادة تعيين كلمة المرور بنجاح.",
      redirecting: "جاري إعادة التوجيه إلى الصفحة الرئيسية...",
      invalidLink: "هذا الرابط غير صالح أو منتهي الصلاحية. يرجى طلب رابط جديد.",
      backToLogin: "العودة لتسجيل الدخول",
      error: "خطأ",
      mismatch: "كلمتا المرور غير متطابقتين",
      tooShort: "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
    },
    wishlist: {
      badge: "المفضلة",
      title: "قائمة الأمنيات",
      loginPrompt: "سجّل الدخول لعرض قائمة أمنياتك",
      signIn: "تسجيل الدخول",
      empty: "قائمة أمنياتك فارغة",
      explore: "استكشف المجموعة",
    },
  },
} as const;

export type Language = "en" | "ar";
export type TranslationKeys = (typeof translations)["en"];
